<p-confirmDialog [header]="configConfirmation?.header? configConfirmation?.header! : 'Confirmation'" [style]="{width: '500px'}" [baseZIndex]="10000"></p-confirmDialog>
